import React, { useMemo } from 'react';
import FilterChip from '../filterChip/FilterChip';
import ContextualMenu, {
    ContextualMenuItem,
} from '../contextualMenu/ContextualMenu';

export type MenuItem = ContextualMenuItem;

interface Props {
    items: MenuItem[];
    label: string;
    onRemove?: () => void;
}

const FilterChipBasicWithContextualMenu: React.FC<Props> = (props) => {
    const [
        anchorElement,
        setAnchorElement,
    ] = React.useState<HTMLElement | null>(null);
    const [clicked, setClicked] = React.useState<boolean>(false);

    const { items, label, onRemove } = props;

    const singleLevelList = useMemo<ContextualMenuItem[]>(
        (): ContextualMenuItem[] =>
            items.map(
                (item: MenuItem): ContextualMenuItem => ({
                    ...item,
                    onClick: (): void => {
                        setAnchorElement(null);
                        setClicked(false);
                        if (item.onClick !== undefined) {
                            item.onClick();
                        }
                    },
                })
            ),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [items, clicked, setClicked]
    );

    const handleExpand = (event: React.MouseEvent<HTMLElement>): void => {
        event.stopPropagation();
        setClicked(true);
        setAnchorElement(event.currentTarget);
    };

    const handleCollapse = (): void => {
        setClicked(false);
        setAnchorElement(null);
    };

    return (
        <>
            <FilterChip
                clicked={clicked}
                label={label}
                onCollapse={handleCollapse}
                onExpand={handleExpand}
                onRemove={onRemove}
            />
            <ContextualMenu
                anchorElement={anchorElement}
                handleClose={handleCollapse}
                singleLevelList={singleLevelList}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
            />
        </>
    );
};

export default FilterChipBasicWithContextualMenu;
